<template>
  <div>
    <div class="updateRollNumber text-left mb-3">
      <b-button variant="primary" size="md" :disabled="rollNumberBtn.disabled" @click="updateRollNumber()">
        {{ rollNumberBtn.text }}
      </b-button>
      <b-button variant="danger" class="ml-3" size="md" :disabled="rollNumberBtn.disabled"
        @click="$emit('rollNumbersUpdated')">
        Cancel
      </b-button>
    </div>

    <b-row>
      <b-col md="6">
        <table class="table table-striped table-bordered w-100">
          <thead class="thead-dark">
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left" style="width: 200px;">Roll Number</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(student, index) in studentRollNumbers" :key="index">
              <td class="text-left">{{ student.name }}</td>
              <td class="text-left" style="width: 200px;">
                <b-form-input v-model="student.roll_number" class="text-left" placeholder="Enter Roll Number"
                  style="width: 180px;"></b-form-input>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

  </div>
</template>

<script>
export default {
  props: ["listOfUsersEnrolled", "selectedSubgroupUsers", "groupInfo"],
  created() {
    this.prepareUsersRollnumberList();
  },
  data() {
    return {
      studentRollNumbers: [],
      rollNumberBtn: {
        text: "Submit",
        disabled: false,
      },
      responseErrors: {},
      responseSuccess: {},
    };
  },
  methods: {
    prepareUsersRollnumberList() {
      this.studentRollNumbers = [];
      this.listOfUsersEnrolled.forEach((student) => {
        const studentId = student.id;
        this.selectedSubgroupUsers.forEach((selectedId) => {
          if (studentId == selectedId) {
            this.studentRollNumbers.push({
              name: student.first_name + " " + (student.last_name || ""),
              institution_user_id: student.pivot.institution_user_id,
              roll_number: student.roll_number || "",
            });
          }
        });
      });
    },
    async updateRollNumber() {
      this.rollNumberBtn.text = "Updating...";
      this.rollNumberBtn.disabled = true;
      let groupUrl = this.$store.getters.getAPIKey.enrollSubGroupUser;
      const url = groupUrl.replace("usersubgroup_id", this.groupInfo.id);
      const studentData = {
        institution_users_roll_number: this.studentRollNumbers.map((student) => ({
          institution_user_id: student.institution_user_id,
          roll_number: student.roll_number,
        })),
      };

      try {
        await this.$axios.post(url, studentData);
        this.responseSuccess["created"] = "RollNumbers Updated!";
        this.$toast.success("Roll Numbers Updated Successfully", {
          position: "top",
          duration: 3000,
        });
        this.clearResponse();
      } catch (error) {
        this.$toast.error(
          error.response?.status === 500
            ? "Something went wrong, Please try again later!"
            : "Something went wrong, Please check the input fields",
          { position: "top", duration: 3000 }
        );
        this.clearResponse();
      }
    },
    clearResponse() {
      this.rollNumberBtn.text = "Submit";
      setTimeout(() => {
        if (this.responseSuccess["created"]) {
          this.$emit("rollNumbersUpdated");
        }
        this.rollNumberBtn.disabled = false;
      }, 3000);
    },
  },
};
</script>
